const listSettingsActionPrefix = '@list-settings/';

/* List of Redux constants */
export const LIST_SETTINGS_SET_DATA = `${listSettingsActionPrefix}set-data`;


// WEBPACK FOOTER //
// ./src/actions/list-settings/types.js